import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FocusInputType, LocalService, LookupType, PurchaseEntryInitialization, Status, Wrapper10 } from 'src/service/local.service';
import { LookupService } from 'src/service/lookup.service';

@Component({
  selector: 'app-lookup-edit',
  templateUrl: './lookup-edit.component.html',
  styleUrl: './lookup-edit.component.scss'
})
export class LookupEditComponent {
  @ViewChild('content_lookup_edit')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() lookupType: LookupType = LookupType.None;
  @Input() id: string = '';

  wrapper: Wrapper10;

  message: string = ''; isRedAlert: boolean = true;

  purchaseEntryInitialization: PurchaseEntryInitialization;

  pageNameId = '_lookup_edit_';
  elementIds: any = {
    code: 'txt' + this.pageNameId + 'code',
    title: 'txt' + this.pageNameId + 'title',
    first_name: 'txt' + this.pageNameId + 'title_m',
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private lookupService: LookupService) {
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {

  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.lookupService.getLookup(this.id).subscribe(result => {
      this.wrapper = result;
      setTimeout(() => {
        this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
      }, 100);
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {

      } break;
      case 2: {
        //Save product
        this.onSave();
      } break;
    }
  }

  onSave() {
    if (this.doCheck()) {
      this.wrapper.content.v2 = this.lookupType.toString();
      this.lookupService.saveLookup(this.wrapper).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        switch (result.status) {
          case Status.Success: {
            this.onCloseTrigger();
          } break;
        }
      });
    }
  }

  doCheck() {
    let message = '';
    this.isRedAlert = true;

    if (this.lookupType == LookupType.None) {
      message = this.localService.languageContent.lookup.need_type;
    }else if (!this.wrapper.content.v1 || !this.wrapper.content.v1.trim()) {
      message = this.localService.languageContent.lookup.need_code;
      this.localService.onFocusNextInput(this.elementIds.code, FocusInputType.TextBox);
    } else if (!this.wrapper.languageContents || this.wrapper.languageContents.filter(x => x.v3.trim() != '').length == 0) {
      message = this.localService.languageContent.lookup.need_title;
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    }

    this.message = message;
    if (this.message != '') {
      //this.localService.showInformation(this.message, this.isRedAlert);
    }
    return message == '';
  }

  onEmptyLanguageContainerAdded(languageContents: any, index) {
    switch (index) {
      case 1: {
        this.wrapper.languageContents = languageContents;
      } break;
    }
  }
}
